import { render, staticRenderFns } from "./AuxiliaryMenuButton.vue?vue&type=template&id=36239bf6&scoped=true"
import script from "./AuxiliaryMenuButton.vue?vue&type=script&lang=js"
export * from "./AuxiliaryMenuButton.vue?vue&type=script&lang=js"
import style0 from "./AuxiliaryMenuButton.vue?vue&type=style&index=0&id=36239bf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36239bf6",
  null
  
)

export default component.exports